
import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { PendingAction } from "@/types/movie";

/**
 * Hook for deleting movies
 * FIXED: Removed auth error handling to prevent page refresh
 */
export const useMovieDelete = (
  pendingActions: PendingAction[],
  removePendingAction: (actionId: string) => void,
  removeMovieFromState: (tmdbId: number) => void
) => {
  return useCallback(async (tmdbId: number) => {
    try {
      console.log(`🗑️ Deleting movie with tmdbId: ${tmdbId}`);
      
      // Cancel any pending actions for this movie
      const moviePendingActions = pendingActions.filter(action => action.movieId === tmdbId);
      moviePendingActions.forEach(action => {
        window.clearTimeout(action.timeoutId);
        removePendingAction(action.id);
      });
      
      // Delete from database
      const { error } = await supabase
        .from('user_movies')
        .delete()
        .eq('tmdb_id', tmdbId);
      
      if (error) {
        console.error('❌ Error deleting movie:', error);
        return;
      }
      
      console.log('✅ Movie deleted successfully');
      
      // Remove from local state
      removeMovieFromState(tmdbId);
    } catch (error) {
      console.error('Error deleting movie:', error);
      // Just log - no navigation or exceptions
    }
  }, [pendingActions, removePendingAction, removeMovieFromState]);
};
